import { AnyAction } from 'redux';

import { REMOVE_GUEST_VIRTUAL_BACKGROUND, UPDATE_GUEST_VIRTUAL_BACKGROUND } from './actions';
import type { GuestsState } from './types';

export const initialState: GuestsState = {
  authToken: null,
  id: null,
};

export default (state = initialState, action: AnyAction): GuestsState => {
  switch (action.type) {
    case UPDATE_GUEST_VIRTUAL_BACKGROUND:
      return {
        ...state,
        virtual_background: action.payload.virtualBackground,
      };

    case REMOVE_GUEST_VIRTUAL_BACKGROUND:
      return {
        ...state,
        virtual_background: undefined,
      };

    default:
      return state;
  }
};
